import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ApiMessageService {

  constructor(private toastr: ToastrService) { }

  // for error, info, warning messages
  async getMessages(messages : any){
    messages.forEach((msg: any) => {
      if (msg.msgType == "Error") {
        this.toastr.error(msg.message);
      }
      else if (msg.msgType == "Info") {
        this.toastr.info(msg.message);
      }
      else if (msg.msgType == "Warning") {
        this.toastr.warning(msg.message);
      }
      else if(msg.msgType == "Success"){
        this.toastr.success(msg.message);
      }
    });
  }

  // for success message
  async getMessage(message : string){
    this.toastr.success(message);
  }

  async handleError(err: any, fallbackMessage: string = 'An unexpected error occurred. Please try again.') {
   const message =
    err?.error?.errors?.[0]?.message ||
    fallbackMessage;
  this.toastr.error(message, 'Error!');
}

}
